function Header() {
	return (
		<header>
			<h1><strong>Anime Collections</strong> (MyAnimeList)</h1>
		</header>
	)
}

export default Header
